var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.labelText)?_c('label',{class:'subtitle-2 gray70--text d-inline-flex ' + _vm.labelPosition,attrs:{"for":_vm.idElement}},[_vm._v(" "+_vm._s(_vm.labelText)+" ")]):_vm._e(),_c('v-select',_vm._g(_vm._b({attrs:{"id":_vm.idElement}},'v-select',_vm.defaultConfigs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }